import useGet from '@/core/composables/api/useGet'
import { onMounted } from 'vue'
import type { SurveyState } from '@/modules/survey/models/survey-state'
import type { Member } from '@/core/models/member/member'

export const useAssessments = () => {
  const { data, load, status, reload } = useGet<AssessmentPreview[]>('assessment')
  onMounted(() => load())
  return {
    data,
    load,
    reload,
    status,
  }
}

export interface AssessmentPreview {
  readonly id: string
  readonly title?: string
  readonly feedbackTopic: { id: string; title: string; icon?: string }
  readonly state: SurveyState
  readonly dueAt?: string
  readonly createdAt: string
  readonly coacheeCount: number
  readonly peerCount: number
  readonly coachees: ReadonlyArray<Member>
  readonly peers: ReadonlyArray<Member>
  readonly completedTandemCount: number
  readonly totalTandemCount: number
  readonly includeSelfFeedback: boolean
}
